import { OrderFeature } from '@aloft/toolkit-shared';

import { ADDITIONAL_FEATURE_KEYS, BASEMENT_SCA_ROW_KEYS } from '../constants.ts';
import { AdditionalFeatureKey, SalesComparisonRows } from '../types.ts';

export const isBasementSalesComparisonRow = (fieldKeys: SalesComparisonRows[0]['key']): boolean =>
  fieldKeys.some((fieldPath) =>
    (BASEMENT_SCA_ROW_KEYS as readonly string[]).includes(fieldPath as string),
  );

export const shouldIncludeSalesComparisonRow = ({
  field,
  orderFeatures,
  includeTotalCostToCure,
  includeCostApproach,
  cellValues,
  hasAdjustmentValues,
}: {
  field: SalesComparisonRows[0];
  orderFeatures: OrderFeature[];
  includeTotalCostToCure: boolean;
  includeCostApproach: boolean;
  cellValues: (string | undefined)[];
  hasAdjustmentValues?: boolean;
}): boolean => {
  if (!includeTotalCostToCure && field.adjustment === 'totalCostToCureAdjustment') {
    return false;
  }

  if (isBasementSalesComparisonRow(field.key)) {
    return orderFeatures.includes('basement');
  }

  if (field.adjustment === 'manualCostAdjustment') {
    if (!includeCostApproach) return false;
    if (orderFeatures.includes('manualCost')) return true;
    return cellValues.some((v) => v && v !== 'None');
  }

  if (field.adjustment === 'otherAdjustments') {
    if (orderFeatures.includes('other') || hasAdjustmentValues) return true;
    return cellValues.some((v) => {
      const trimmed = v?.trim();
      return Boolean(trimmed && trimmed !== 'Other' && trimmed !== 'None');
    });
  }

  const nbOfFieldsWithValue = cellValues.filter((v) => !!v).length;

  return !(
    nbOfFieldsWithValue === 0 &&
    field.key.some((fieldPath) =>
      ADDITIONAL_FEATURE_KEYS.includes(fieldPath as AdditionalFeatureKey),
    )
  );
};
